import { useEventListener } from 'ahooks';
import { useCallback, useLayoutEffect, useState } from 'react';

type ElementSize = {
  width: number;
  height: number;
};

export function useElementSize<T extends HTMLElement = HTMLDivElement>() {
  const [ref, setRef] = useState<T | null>(null);
  const [size, setSize] = useState<ElementSize>({
    width: 0,
    height: 0,
  });

  // Prevent too many rendering using useCallback
  const handleSize = useCallback(() => {
    setSize({
      width: ref?.offsetWidth || 0,
      height: ref?.offsetHeight || 0,
    });
  }, [ref]);

  useEventListener('resize', handleSize);

  useLayoutEffect(() => {
    handleSize();
  }, [ref, handleSize]);

  return [setRef, size] as const;
}
